import '../styles/main.css';

import App from './pages/app';
import NotificationService from './services/notification-service';

async function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register('/sw.bundle.js', {
        scope: '/'
      });
      
    } catch (error) {
      
    }
  }
}

document.addEventListener('DOMContentLoaded', async () => {
  await registerServiceWorker();

  const app = new App();
  window.app = app;
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener('message', (event) => {
      const data = event.data;
      if (data && data.type === 'NEW_NOTIFICATION') {
        NotificationService.addNotification({
          id: 'notif_' + Date.now(),
          title: data.data.title,
          message: data.data.message,
          timestamp: data.data.timestamp,
        });
        if (window.app && window.app.presenters?.notifications?.refresh) {
          window.app.presenters.notifications.refresh();
        }
      }
    });
  }
  const guestLoginBtn = document.getElementById('guest-login-btn');
  if (guestLoginBtn) {
    guestLoginBtn.addEventListener('click', () => {
      app.navigateTo('auth');
    });
  }
  
  window.addEventListener('error', (e) => {
    if (app && app.showToast) {
      app.showToast('Terjadi kesalahan sistem', 'error');
    }
  });
  
  window.addEventListener('unhandledrejection', (e) => {
    if (app && app.showToast) {
      app.showToast('Terjadi kesalahan jaringan', 'error');
    }
  });
});